const Page = ({ className = "", children }) => (
  <div className={`container mx-auto px-6 2xl:px-12 ${className}`}>{children}</div>
);

export default Page;
